export default function ({ store, redirect }) {
  if (store.state['potential-worker'].workerId === 0) {
    return redirect('/empresas/trabajadores-potenciales')
  }
}
